module.exports = __webpack_public_path__ + "assets/images/microlesson.bcca99c5840b494ca6a886890965b617.svg";